import { type ComponentProps, memo } from 'react';

export type AssetModalContentDesktopLayoutFooterProps = Pick<ComponentProps<'footer'>, 'children'>;

export const AssetModalContentDesktopLayoutFooter = memo(({ children }: AssetModalContentDesktopLayoutFooterProps) => {
  return (
    <footer className="absolute inset-x-0 bottom-0 z-10 flex h-12 w-full shrink-0 items-center ads:bg-glass/70 bg-gray-1/70 px-2 ads:text-metadata text-gray-10">
      {children}
    </footer>
  );
});

AssetModalContentDesktopLayoutFooter.displayName = 'AssetModalContentDesktopLayoutFooter';
